export default __webpack_public_path__ + "static/media/pic2.b40fd1e2.jpg";